import RoleManagement from './role_management'

export default {
  "role_management": RoleManagement
}



// WEBPACK FOOTER //
// ./src/pages/role_management/index.js